export default __webpack_public_path__ + "static/media/cabourg3.6b44743e.jpg";